<template>
  <v-app>
    
    <Drawer />
    <v-content>
      
      <router-view></router-view>
    </v-content>
  </v-app>
</template>

<script>
import Drawer from "@/components/Drawer";

export default {
  name: "App",
  components: {
    Drawer,
   
  },
  data() {
    return {};
  }
};
</script>